import replaceString from 'replace-string';
import urlJoin from 'url-join';

export default class DPIncUtils {
	constructor(config) {
		if (config.dpDebugEn) console.log('DPIncUtils');
	}

	static isVariableUrl(url) {
		const start = url.indexOf('{');
		const stop = url.indexOf('}');
		return start >= 0 && stop > start;
	}

	static fillUrlVariables(urlVars, url) {
		if (urlVars && url) {
			Object.keys(urlVars).forEach((varId) => {
				url = replaceString(url, `{${varId}}`, urlVars[varId]);
			});
		}
		return url;
	}

	static simpleObjectToStr(obj, separator = '|', valueNameSeparator = '=') {
		let res = '';
		if (obj) {
			Object.keys(obj).forEach((key, idx) => {
				if (idx != 0) res += separator;
				res += `${key}${valueNameSeparator}${obj[key]}`;
			});
		}
		return res;
	}

	static strToSimpleObject(str, separator = '|', valueNameSeparator = '=') {
		const res = {};
		if (str) {
			const items = str.split(separator);
			if (items) {
				items.forEach((item) => {
					const parts = item.split(valueNameSeparator);
					if (parts && parts.length >= 2) {
						res[parts[0]] = parts[1];
					}
				});
			}
		}
		return res;
	}

	static getInfoIconHtml(className, text, title = '') {
		if (title) text = `<strong class="info-tip-title">${title}</strong>${text}`;
		return $(`<div class="${className}"></div>`).attr('data-info-text', text);
	}

	static strSeparatedLastPart(text, delimiter = '.', def = '') {
		const dataParts = text.split(delimiter);
		if (dataParts && dataParts.length > 0) {
			return dataParts[dataParts.length - 1];
		}
		return def;
	}

	static strSeparatedFirstPart(text, delimiter = '.', def = '') {
		const dataParts = text.split(delimiter);
		if (dataParts && dataParts.length > 0) {
			return dataParts[0];
		}
		return def;
	}

	static filterQMarkWithNoSlash(url) {
		const qMarkIdx = url.indexOf('?');
		if (qMarkIdx >= 0) {
			if (qMarkIdx === 0 || url[qMarkIdx - 1] != '/') {
				url = `${url.substring(0, qMarkIdx)}/${url.substring(qMarkIdx)}`;
			}
		}
		return url;
	}

	static forceQMarkWithoutSlash(url) {
		const qMarkIdx = url.indexOf('?');
		if (qMarkIdx > 0 && url[qMarkIdx - 1] == '/') {
			url = url.substring(0, qMarkIdx - 1) + url.substring(qMarkIdx);
		}
		return url;
	}

	static sanitizePossibleRelativeUrl(url, mainSiteUrl, forceSlashBeforeQMark = false) {
		if (url.startsWith('/')) {
			url = urlJoin(mainSiteUrl, url);
			if (forceSlashBeforeQMark) {
				url = DPIncUtils.filterQMarkWithNoSlash(url);
			}
		}
		return url;
	}

	static absToRelativeUrl(url, mainSiteUrl) {
		if (mainSiteUrl && url.startsWith(mainSiteUrl)) {
			url = url.substring(mainSiteUrl.length);
			if (!url.startsWith('/')) url = `/${url}`;
		}
		return url;
	}

	static removeURLParameter(url, parameter) {
		// prefer to use l.search if you have a location/link object
		const urlparts = url.split('?');
		if (urlparts.length >= 2) {
			const prefix = `${encodeURIComponent(parameter)}=`;
			const pars = urlparts[1].split(/[&;]/g);

			// reverse iteration as may be destructive
			for (let i = pars.length; i-- > 0;) {
				// idiom for string.startsWith
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {
					pars.splice(i, 1);
				}
			}

			return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
		}
		return url;
	}

	static removeURLParameters(url, parameters) {
		let paramKeys = parameters;
		if (!Array.isArray(parameters)) paramKeys = Object.keys(parameters);
		paramKeys.forEach((parameter) => {
			url = DPIncUtils.removeURLParameter(url, DPIncUtils.getDpUrlParamName(parameter, parameters));
		});
		return url;
	}

	static unifyUrl(url, removeQuery = true, forceSlashBeforeQMark = false, removeHash = true, removeTrailingSlashes = true, prependSlash = false) {
		if (url) {
			url = DPIncUtils.strSeparatedLastPart(url, '://', url);
			if (url && url.startsWith('www.')) url = url.substring(4);
			if (url && removeHash) url = DPIncUtils.strSeparatedFirstPart(url, '#', url);
			if (url && removeQuery) {
				url = DPIncUtils.strSeparatedFirstPart(url, '?', url);
			} else if (forceSlashBeforeQMark) {
				url = DPIncUtils.filterQMarkWithNoSlash(url);
			}
			if (url) {
				let regExp = /\/+$/;
				if (!removeTrailingSlashes) {
					regExp = /^\/+/g;
				}
				url = url.replace(regExp, '');
			}
			if (url && prependSlash) {
				url = `/${url}`;
			}
		}
		if (!url) url = '/';
		return url;
	}

	static getDpUrlParamName(id, queryParamsDefinitions) {
		let res = id;
		if (queryParamsDefinitions) res = queryParamsDefinitions[id];
		return res;
	}

	static getDpUrlParam(id, queryParamsDefinitions, currentUrl = null, defVal = null) {
		let res = defVal;
		const key = DPIncUtils.getDpUrlParamName(id, queryParamsDefinitions);
		if (key) {
			if (!currentUrl) currentUrl = new URL(window.location);
			res = currentUrl.searchParams.get(key);
		}
		return res;
	}

	static setDpUrlParam(id, queryParamsDefinitions, val, postfixAmpersand = true) {
		let res = '';
		const key = DPIncUtils.getDpUrlParamName(id, queryParamsDefinitions);
		if (key) {
			res = key + '=' + val;
			if (postfixAmpersand) res += '&';
		}
		return res;
	}

	static buildDpQueryString(params, queryParamsDefinitions, prefix = '?', unmappedParams = null) {
		let res = prefix;
		if (unmappedParams) {
			const idsUm = Object.keys(unmappedParams);
			idsUm.forEach((id) => {
				if (unmappedParams[id] !== null && unmappedParams[id] !== undefined && unmappedParams[id] !== '')
					res += id + '=' + unmappedParams[id] + '&';
			});
		}
		if (params) {
			const ids = Object.keys(params);
			ids.forEach((id) => {
				if (params[id] !== null && params[id] !== undefined && params[id] !== '')
					res += DPIncUtils.setDpUrlParam(id, queryParamsDefinitions, params[id]);
			});
		}

		if (res && res[res.length - 1] == '&') res = res.substr(0, res.length - 1);
		if (res == prefix) res = '';
		return res;
	}

	static decodeStepParamAdvancedVal(value, paramName, stepDefs, mainValOnlyForSimpleVal = true, onlyValForExtProps = false) {
		const stepDef = stepDefs?.[paramName];
		const extCfg = stepDef?.ext;
		let res = {
			val: value ?? stepDef?.defMain,
			ext: {}
		};
		if (value?.startsWith('base64__') || extCfg) {
			let dataObj = null;
			if (value?.startsWith('base64__')) {
				const dataObjStr = atob(value.substr(8));
				dataObj = dataObjStr ? JSON.parse(dataObjStr) : null;
				res.val = dataObj?.val ?? stepDef?.defMain;
			}
			if (extCfg) {
				Object.keys(extCfg).forEach(id => {
					if (onlyValForExtProps) {
						res.ext[id] = dataObj?.ext?.[id] ?? extCfg[id]?.def;
					}
					else {
						res.ext[id] = {
							...extCfg[id],
							val: dataObj?.ext?.[id] ?? extCfg[id]?.def
						};
					}
				});
			}

		} else if (mainValOnlyForSimpleVal) {
			res = value;
		}
		return res;
	}

	static encodeStepParamAdvancedVal(value, paramName, stepDefs) {
		const extCfg = stepDefs?.[paramName]?.ext;
		return extCfg ? 'base64__' + btoa(JSON.stringify(value)) : value;
	}

	static initStepParams(stepDefinitions) {
		const res = {};
		Object.keys(stepDefinitions).forEach(paramName => {
			let mainVal = '';
			if (stepDefinitions[paramName]) {
				mainVal = stepDefinitions[paramName].def || '';
				if (stepDefinitions[paramName].ext) {
					let extVals = {};
					Object.keys(stepDefinitions[paramName].ext).forEach(extName => {
						extVals[extName] = stepDefinitions[paramName].ext[extName].def;
					});
					mainVal = {
						val: mainVal,
						ext: extVals
					};
				}
			}
			res[paramName] = mainVal;
		});
		return res;
	}

	static getNthStr(idx) {
		if (idx !== false && !isNaN(idx)) {
			let res = '';
			switch (idx) {
				case 1: res = '1st'; break;
				case 2: res = '2nd'; break;
				case 3: res = '3rd'; break;
				default: res = `${idx}th`; break;
			}
			return res;
		}
		return '';
	}


	static setTextStyles(rootDivEl, textStylesCfg, mobileBreakPoint = -1) {
		let mobSizeCoef = 1;
		if (mobileBreakPoint > 0 && $(window).width() <= mobileBreakPoint) mobSizeCoef = 0.8;
		if (textStylesCfg && rootDivEl) {
			const text_styles = { ...textStylesCfg };
			Object.keys(text_styles).forEach(propName => {
				if (text_styles[propName] || text_styles[propName] == '0') {
					let val = text_styles[propName];
					if (!propName.endsWith('font')) {
						val = Math.round(mobSizeCoef * text_styles[propName]) + 'px';
					}
					rootDivEl.style.setProperty(`--${propName}`, val);
				}
				else {
					rootDivEl.style.removeProperty(`--${propName}`);
				}
			});
			if (text_styles.h2_font_size || text_styles.h2_font_size == 0 && text_styles.h5_font_size || text_styles.h5_font_size == 0) {
				const unit = (text_styles.h2_font_size - text_styles.h5_font_size) / 4;
				for (let i = 1; i <= 6; i++) {
					if (i === 2 || i === 5) continue;
					const unitCnt = i - 2;
					rootDivEl.style.setProperty(`--h${i}_font_size`, Math.round(mobSizeCoef * (text_styles.h2_font_size - unitCnt * unit)) + 'px');
				}
			}
			if (text_styles.h2_mb || text_styles.h2_mb == 0 && text_styles.h5_mb || text_styles.h5_mb == 0) {
				const unit = (text_styles.h2_mb - text_styles.h5_mb) / 4;
				for (let i = 1; i <= 6; i++) {
					if (i === 2 || i === 5) continue;
					const unitCnt = i - 2;
					rootDivEl.style.setProperty(`--h${i}_mb`, Math.round(mobSizeCoef * (text_styles.h2_mb - unitCnt * unit)) + 'px');
				}
			}
		}
	}
}
